import { Link } from 'react-router-dom';

function Rahmen({ titel, children }: { titel: string; children: React.ReactNode }) {
  return (
    <div className="container" style={{ maxWidth: '44rem' }}>
      <p className="label">
        <Link to="/">← Startseite</Link>
      </p>
      <h1>{titel}</h1>
      {children}
    </div>
  );
}

export function Impressum() {
  return (
    <Rahmen titel="Impressum">
      <p>Angaben gemäß § 5 DDG</p>
      <p>
        Burkhard Schäpers
        <br />
        Am Stüssgeshof 10
        <br />
        41564 Kaarst
      </p>
      <p>
        <strong>Kontakt:</strong> <a href="mailto:kontakt@guenni-eis.de">kontakt@guenni-eis.de</a>
      </p>
      <p>
        <strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</strong>
        <br />
        Burkhard Schäpers, Anschrift wie oben
      </p>
      <p style={{ color: 'var(--espresso-70)', fontSize: '0.9rem' }}>
        GünniEis ist ein privates, nicht-kommerzielles Hobbyprojekt. Die Bewertungen geben
        die persönliche Meinung der jeweiligen Verkosterinnen und Verkoster wieder.
      </p>
    </Rahmen>
  );
}

export function Datenschutz() {
  return (
    <Rahmen titel="Datenschutzerklärung">
      <h2>I. Informationen über die Verarbeitung Ihrer Daten gemäß Art. 13 DS-GVO</h2>

      <h3>1. Verantwortlicher</h3>
      <p>
        Verantwortlich für diese Website ist Burkhard Schäpers, Am Stüssgeshof 10, 41564
        Kaarst, E-Mail: <a href="mailto:kontakt@guenni-eis.de">kontakt@guenni-eis.de</a>.
      </p>
      <p>
        Ein Datenschutzbeauftragter ist nicht bestellt, da hierzu bei diesem privaten,
        nicht-kommerziellen Hobbyprojekt mit sehr kleinem Nutzerkreis keine gesetzliche
        Pflicht besteht (§ 38 BDSG, Art. 37 DS-GVO).
      </p>

      <h3>2. Bereitstellung der Website</h3>
      <p>
        <strong>a. Welche Daten werden für welchen Zweck verarbeitet?</strong>
        <br />
        Bei jedem Zugriff auf die Website verarbeitet die zur Auslieferung eingesetzte
        Infrastruktur (Amazon CloudFront) technisch notwendig unter anderem Ihre
        IP-Adresse, um die Inhalte an Ihr Gerät ausliefern zu können. Eigene, für Sie
        einsehbare Zugriffsprotokolle werden dabei nicht geführt. Die Backend-Funktionen
        der Anwendung (AWS Lambda) schreiben im Fehlerfall technische Protokolle (Amazon
        CloudWatch), um die Funktionsfähigkeit und Sicherheit der Anwendung
        sicherzustellen. Hierin liegt auch unser berechtigtes Interesse an der
        Verarbeitung.
        <br />
        <strong>b. Rechtsgrundlage:</strong> Art. 6 Abs. 1 Buchstabe f DS-GVO.
        <br />
        <strong>c. Empfänger:</strong> Die Website wird bei Amazon Web Services EMEA
        SARL, 38 Avenue John F. Kennedy, L-1855 Luxemburg, gehostet. AWS empfängt die
        genannten Daten als Auftragsverarbeiter; mit AWS besteht ein
        Auftragsverarbeitungsvertrag.
        <br />
        <strong>d. Speicherdauer:</strong> Technische Fehlerprotokolle der
        Backend-Funktionen werden automatisiert nach 7 Tagen gelöscht.
      </p>

      <h3>3. Nutzerkonten</h3>
      <p>
        Für angemeldete Nutzer werden E-Mail-Adresse, ein Anzeigename und die zugewiesene
        Rolle gespeichert (Amazon Cognito). Konten werden ausschließlich durch einen
        Verwalter angelegt. Rechtsgrundlage ist Art. 6 Abs. 1 Buchstabe f DS-GVO
        (berechtigtes Interesse an einer geschlossenen, nur für eingeladene Personen
        zugänglichen Anwendung). Die Daten werden gelöscht, sobald das Konto nicht mehr
        benötigt wird.
      </p>

      <h3>4. Verkostungsdaten und Fotos</h3>
      <p>
        Bewertungen, Freitexte und je Verkostung ein Foto werden gespeichert und sind
        für angemeldete Nutzer sichtbar. Fotos liegen in einem privaten Speicher (Amazon
        S3) und werden nur über kurzlebige, signierte Links ausgeliefert.
      </p>

      <h3>5. Kartendienst</h3>
      <p>
        Die Kartenansicht nutzt Amazon Location Service (EU-Region). Die Karte wird erst
        nach ausdrücklichem Klick geladen. Dabei werden technische Daten – unter anderem
        die IP-Adresse – an den Kartendienst übermittelt.
      </p>

      <h3>6. Cookies</h3>
      <p>
        Es werden ausschließlich technisch notwendige Sitzungs-Cookies für die Anmeldung
        gesetzt. Kein Tracking, keine Analyse-Dienste.
      </p>

      <h3>7. Betroffenenrechte</h3>
      <p>
        <strong>a. Recht auf Auskunft:</strong> Sie können Auskunft nach Art. 15 DS-GVO
        über Ihre personenbezogenen Daten verlangen, die wir verarbeiten.
        <br />
        <strong>b. Recht auf Widerspruch:</strong> Sie haben ein Recht auf Widerspruch
        aus besonderen Gründen (siehe unten, Abschnitt II).
        <br />
        <strong>c. Recht auf Berichtigung:</strong> Sollten die Sie betreffenden Angaben
        nicht (mehr) zutreffend sein, können Sie nach Art. 16 DS-GVO eine Berichtigung
        verlangen. Sollten Ihre Daten unvollständig sein, können Sie eine
        Vervollständigung verlangen.
        <br />
        <strong>d. Recht auf Löschung:</strong> Sie können nach Art. 17 DS-GVO die
        Löschung Ihrer personenbezogenen Daten verlangen.
        <br />
        <strong>e. Recht auf Einschränkung der Verarbeitung:</strong> Sie haben nach Art.
        18 DS-GVO das Recht, eine Einschränkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen.
        <br />
        <strong>f. Recht auf Beschwerde:</strong> Wenn Sie der Ansicht sind, dass die
        Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt, haben
        Sie nach Art. 77 Abs. 1 DS-GVO das Recht, sich bei einer
        Datenschutzaufsichtsbehörde eigener Wahl zu beschweren. Hierzu gehört auch die
        für den Verantwortlichen zuständige Datenschutzaufsichtsbehörde: Landesbeauftragte
        für Datenschutz und Informationsfreiheit Nordrhein-Westfalen,{' '}
        <a href="https://www.ldi.nrw.de/kontakt/ihre-beschwerde" target="_blank" rel="noreferrer noopener">
          https://www.ldi.nrw.de/kontakt/ihre-beschwerde
        </a>
        .
        <br />
        <strong>g. Recht auf Datenübertragbarkeit:</strong> Für den Fall, dass die
        Voraussetzungen des Art. 20 Abs. 1 DS-GVO vorliegen, steht Ihnen das Recht zu,
        sich Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines
        Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen.
        Die Bereitstellung der Website beruht nicht auf einer Einwilligung nach Art. 6
        Abs. 1 Buchstabe a DS-GVO oder auf einem Vertrag nach Art. 6 Abs. 1 Buchstabe b
        DS-GVO, sondern ist nach Art. 6 Abs. 1 Buchstabe f DS-GVO gerechtfertigt. Die
        Voraussetzungen des Art. 20 Abs. 1 DS-GVO sind insoweit nicht erfüllt.
      </p>

      <h2>II. Recht auf Widerspruch gemäß Art. 21 Abs. 1 DS-GVO</h2>
      <p>
        Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
        ergeben, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten, die
        aufgrund von Art. 6 Abs. 1 Buchstabe f DS-GVO erfolgt, Widerspruch einzulegen.
        Der Verantwortliche verarbeitet die personenbezogenen Daten dann nicht mehr, es
        sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen,
        die die Interessen, Rechte und Freiheiten der betroffenen Person überwiegen, oder
        die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
        Rechtsansprüchen. Die Bereitstellung der Website ist für deren Betrieb zwingend
        erforderlich.
      </p>
    </Rahmen>
  );
}
